<header class="emptyHeaderMain"></header>
<div class="container">
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <h1>Forgot Password</h1>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <form [formGroup]="form">
        <p *ngIf="!sent">
          Enter your email address below and we will send you instructions on
          how to reset your password.
        </p>

        <p *ngIf="sent">
          We have sent you an email containing instructions on how to reset your
          password. If you cannot find the email, wait a few minutes, and also
          make sure to check your spam folder as well. If you still cannot find
          the email, please double-check that the email address you entered is
          spelt correctly and use the "Resend" button below to send it again or
          else get in touch with
          <a href="mailto:information@wedavinci.com" target="_blank">
            information&#64;wedavinci.com
          </a>
          (you might not be registered under that email address)
        </p>

        <div class="form-group mb-3">
          <label class="form-label" for="email-field">Email</label>

          <input
            type="email"
            class="form-control"
            formControlName="email"
            id="email-field"
            required />
        </div>
        <p *ngIf="error" class="form-text">
          We couldn’t find your account with that information Please try
          searching for your email again.
        </p>
        <hr />
        <div class="row">
          <div class="col-md-4 col-lg-3">
            <!--
            <oauth-buttons classes="btn-block"></oauth-buttons>
            -->
          </div>
        </div>
      </form>

      <div>
        <button
          [disabled]="!form.valid || this.pending"
          (click)="submit()"
          class="btn btn-secondary btn-lg">
          <ng-container *ngIf="!sent">Send Password Reset Email</ng-container>
          <ng-container *ngIf="sent">Resend Password Reset Email</ng-container>
        </button>
      </div>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <hr />
</div>
